import { render } from "./offer-details-menu.vue?vue&type=template&id=8ab9daec&scoped=true"
import script from "./offer-details-menu.vue?vue&type=script&lang=js"
export * from "./offer-details-menu.vue?vue&type=script&lang=js"

import "./offer-details-menu.vue?vue&type=style&index=0&id=8ab9daec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ab9daec"]])

export default __exports__